module.exports = __webpack_public_path__ + "img/2020_03-31-Sudbury-prayer.d4e4e704.jpg";